var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAnnuity = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 70.577 70.577"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0v70.577h70.577V0Zm66.577 66.577H4V18.382c22.487-.444 40.947 5.175 52.152 15.957C62.973 40.9 66.577 48.92 66.577 57.523Zm-7.651-35.119C46.964 19.946 27.516 13.933 4 14.382V4h62.577v37.5a39.7 39.7 0 0 0-7.651-10.042",
  "data-name": "Layer 1"
}))));
export default SvgAnnuity;